module.exports = __webpack_public_path__ + "img/mobile/PromoHistory/Promo_Spin_Icon@3x.png?1.0.17";